<template>
    <div class="boxAccordion border border-black bg-white">
        <slot name="summary"></slot>
        <div :class="accordionClass">
            <slot></slot>
        </div>
        <div :class="iconContainerClass" @click="toggleExpand">
            <img :class="toggleIconClass" src="@/assets/images/decoration/arrow-down-black.svg">
        </div>
    </div>
</template>

<script>
export default {
    name: 'BoxAccordion',
    data() {
        return {
            isExpanded: false,
        };
    },
    props: {
        accordionSize: {
            type: String,
            default: 'sm',
        },
        forceExpandState: {
            default: null,
        },
    },
    methods: {
        /**
         * Toggle expanding the accordion.
         *
         * @returns {void}
         */
        toggleExpand() {
            this.isExpanded = !this.isExpanded;
            this.$emit('toggleExpand');
        },
    },
    computed: {
        accordionClass() {
            let accClass = `accordion__${this.accordionSize}`;

            return this.shouldExpand ? `${accClass}--no-scroll ${accClass} ${accClass}--active` : `${accClass}--no-scroll ${accClass}`;
        },
        shouldExpand() {
            if (this.forceExpandState !== null) return this.forceExpandState;

            return this.isExpanded;
        },
        iconContainerClass() {
            return this.shouldExpand ? 'boxAccordion__toggle boxAccordion__toggle--active' : 'boxAccordion__toggle';
        },
        toggleIconClass() {
            return this.shouldExpand ? 'boxAccordion__toggleIcon boxAccordion__toggleIcon--active' : 'boxAccordion__toggleIcon';
        },
    },
};
</script>
